const ArrowSmall = ({ className = '' }) => (
	<svg
		width={11}
		height={7}
		viewBox="0 0 11 7"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M0.158662 6.11502L5.45919 0.344417L10.9997 5.88497L0.158662 6.11502Z"
			fill="currentColor"
		/>
	</svg>
)

export default ArrowSmall
